import '../../../common/action-required-card/components/ActionRequiredCard.scss';
import { Button } from 'devextreme-react/button';
import { Popover } from 'devextreme-react/popover';
import { DealerActionRequiredCardProps } from '../types/DealerActionRequiredCardProps';
import { useNavigate } from 'react-router-dom';

export default function DealerActionRequiredCard(props: DealerActionRequiredCardProps) {

    let navigate = useNavigate();

    var statDataItem = props.statData.find(x => x.statID === props.statID);
    const infoElementID = "ar-info-" + props.statID;
    const totalCount = statDataItem?.total ?? 0;

    return (
        <div className='ar-button not-mine-ar-button dx-card'>
            <div className='ar-text ar-text-multiline'>{props.text}</div>
            <div className='ar-total'>
                <span>{totalCount}</span>
                <i className='dx-icon dx-icon-Inscyth-Info' id={infoElementID}></i>
            </div>
            <Popover
                target={'#' + infoElementID}
                showEvent='dxhoverstart'
                hideEvent='dxhoverend'
                width={300}
            >
                <div className='ar-description'>{props.description}</div>
            </Popover>
            <div className='button-replacement'>
            </div>
            <Button
                onClick={() => navigate(props.url)}
            >
                <div className="button-text">
                    Active Orders<br />
                    <b>{totalCount}</b>
                </div>
            </Button>
        </div>
    )
} 
